var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',_vm._l((_vm.items),function(o,i){return _c('v-flex',{key:i,staticStyle:{"text-align":"center"}},[_c('v-card',[_c('i',{class:'icon fa-3x '+o.icon}),_c('h3',[_vm._v(_vm._s(o.title))])])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }